export default {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 23.471 24.777",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }